import { normalizeCSSBucketEntry, safeInsertRule } from '@griffel/core';
import { createFallbackRenderer } from './createFallbackRenderer.esm.js';
import { findInsertionPoint } from './findInsertionPoint.esm.js';

const SUPPORTS_CONSTRUCTABLE_STYLESHEETS = /*#__PURE__*/(() => {
  try {
    new CSSStyleSheet();
    return true;
  } catch {
    return false;
  }
})();
let rendererId = 0;
function getCSSStyleSheetForBucket(cssSheetsCache, bucketName, metadata = {}, onStyleSheetInsert) {
  const isMediaBucket = bucketName === 'm';
  const styleSheetKey = isMediaBucket ? bucketName + metadata['m'] : bucketName;
  if (!cssSheetsCache[styleSheetKey]) {
    const styleSheet = new CSSStyleSheet();
    styleSheet.bucketName = bucketName;
    styleSheet.metadata = metadata;
    cssSheetsCache[styleSheetKey] = styleSheet;
    onStyleSheetInsert(styleSheet);
  }
  return cssSheetsCache[styleSheetKey];
}
function insertBefore(arr, sheetToInsert, targetSheet) {
  if (targetSheet === null) {
    return [...arr, sheetToInsert];
  }
  const index = arr.indexOf(targetSheet);
  return [...arr.slice(0, index), sheetToInsert, ...arr.slice(index)];
}
function createShadowDOMRenderer(shadowRoot) {
  if (!SUPPORTS_CONSTRUCTABLE_STYLESHEETS) {
    return createFallbackRenderer(shadowRoot);
  }
  const cssSheetsCache = {};
  const renderer = {
    id: `shadow-dom:${rendererId++}`,
    adoptedStyleSheets: [],
    insertionCache: {},
    stylesheets: {},
    compareMediaQueries: (a, b) => a < b ? -1 : a > b ? 1 : 0,
    insertCSSRules(cssRules) {
      for (const [_styleBucketName, cssBucketEntries] of Object.entries(cssRules)) {
        const styleBucketName = _styleBucketName;
        for (let i = 0, l = cssBucketEntries.length; i < l; i++) {
          const [ruleCSS, metadata] = normalizeCSSBucketEntry(cssBucketEntries[i]);
          const sheet = getCSSStyleSheetForBucket(cssSheetsCache, styleBucketName, metadata, styleSheet => {
            const targetStyleSheet = findInsertionPoint(renderer, styleSheet);
            renderer.adoptedStyleSheets = insertBefore(renderer.adoptedStyleSheets, styleSheet, targetStyleSheet);
            shadowRoot.adoptedStyleSheets = insertBefore(shadowRoot.adoptedStyleSheets, styleSheet, targetStyleSheet);
          });
          if (renderer.insertionCache[ruleCSS]) {
            continue;
          }
          renderer.insertionCache[ruleCSS] = styleBucketName;
          safeInsertRule(sheet, ruleCSS);
        }
      }
    }
  };
  return renderer;
}

export { createShadowDOMRenderer };
//# sourceMappingURL=createShadowDOMRenderer.esm.js.map
